<template>
	<div v-show="bodyIsShow">
		<input type="hidden" id="code" value="" />
		<div id="noSearchInput" class="bodywrap">
			<header>
				<a class="fl searchHeader-back" href="javascript:window.history.go(-1)"></a>
				<span class="title">{{brandName}}<a class="red" href="/city.html">&nbsp;&middot;&nbsp;{{cityName}}&nbsp;<span  class="headright">&rsaquo;</span></a>
				</span>

				<a id="header-search-link" class="header-search-link" href="javascript:void(0);"><em class="header-search-link-icon"></em>搜索</a>

			</header>
			<section class="car-banner-wrap">
				<div class="car-banner">
					<!-- 当前城市为洛阳并且品牌为东风标志的时候展示相应的图片 -->
					<!-- <img v-if="(cityId==98)&&(brandId==8)" class="w100" :src="brandPic" /> -->
					<img class="w100" :src="brandPic" />
					<div class="car-banner-bg"></div>
				</div>
			</section>
			<section>
				<table class="carsaleInfo">
					<tr>
						<td>
							<div class="carsaleInfo-num">本期<span class="orange">{{groupinfo.brandGroupStyleManNum}}</span>人</div>
							<div class="carsaleInfo-txt">已报名</div>
						</td>
						<td class="noborder">
							<div class="carsaleInfo-num">累计<span class="orange">{{groupinfo.brandGroupStyleNum}}</span>人</div>
							<div class="carsaleInfo-txt">已报名</div>
						</td>
					</tr>
				</table>
			</section>
			<section class="clearfix carTAP">
				<!--<p class="clearfix"><label>团购时间：</label><span class="carTAP-content"><php>echo str_replace('开团','',$groupinfo['groupbuyDate']);</php>({$groupinfo.groupbuyWeek})</span></p>-->
				<p class="clearfix"><label style="width:6em">团车节时间：</label><span class="carTAP-content" style="left:6em">报名后客服人员会通知您参加团车节时间</span></p>
				<!--<p class="clearfix"><label>团购地点：</label><span class="carTAP-content">{$choosecity.name}正规4S店<span class="gray">(具体地点以团长通知短信为准)</span></span></p>-->
				<p class="clearfix"><label style="width:6em">团车节价格：</label><span class="carTAP-content" style="left:6em">现场公布</span></p>
				<!--<p class="clearfix"><label style="width:6em">团车节价格：</label><span class="carTAP-content" style="left:6em">现场公布<span id="carsaleInfo-icon" class="carsaleInfo-icon"></span></span></p>-->
				<div id="icon-tip-pop" class="icon-tip-pop icon-tip-pop-show icon-tip-pop-showend"><em></em>1. 销售还在帮您砍价，还不确定底价<br>2. 价格比较低，厂家不允许公开，公开后可能被取消，从而损害消费者利益。</div>
				<p class="red" v-show="promptDiv">温馨提示：{{prompt}}</p>
			</section>
			<section class="detailForm-wrap">
				<a name="baoming"></a>
				<form class="detailForm" onsubmit="return false">
					<div class="form-contril-wrap">
						<div class="form-car-tit">车展车型选择：</div>
						<div class="form-car-select">

							<!-- 报名验证码开始 -->
							<input type="hidden" id="isCheckCode" :value="isCheckCode">
							<!-- 是否进行报名验证 1：验证 0：不验证 -->
							<div v-if="isCheckCode == 1">
								<input type="hidden" id="checkColeUrl" :value="checkColeUrl">
								<!-- 验证图片验证码和发短信 -->
								<input type="hidden" id="checkPhoneCodeUrl" :value="checkPhoneCodeUrl">
								<!-- 验证手机短信验证码 -->
								<input type="hidden" id="temAddApply" :value="temAddApply">
								<!-- ajax请求将报名信息插入临时报名表 -->
							</div>

							<!-- 报名验证码结束 -->
							<input type="hidden" id="cityPy" :value="cityPy">
							<!-- 城市拼音 -->
							<input id="carStyleId" name="carStyleId" class="detailForm-carStyle" type="hidden" :value="brandId +'@#'+carStyleId" />
							<input type="hidden" id="atype" name="atype" value="2">
							<input type="hidden" id="serachUlr" :value="serachUrl" />
							<!-- 搜索记录情况url -->
							<input type="hidden" id="suggesturl" :value="suggesturl">
							<!-- ajax请求url -->
							<input type="hidden" id="bmtype" name="bmtype" :value="brand_tuan">
							<input type="hidden" id="cityId" name="cityId" :value="cityId">
							<input type="hidden" id="brandId" name="brandId" :value="brandId">
							<input type="hidden" name="oc" :value="oc">
							<input type="hidden" id="code" name="code" value="">
							<ul id="form-car-select-ul" class="clearfix">
								<li @click="checkCarStyle(item.styleId)" v-if="(index < 7)" :class="[{'cur':(item.styleId == styleId)}]" v-for="(item,index) in carlist" v-bind:data-rel="brandId+'@#'+item.styleId"><span>{{item.styleName}}</span>
									<em></em>
								</li>
								<li @click="checkCarStyle(item.styleId)" v-if="(index > 6)" :class="[{'cur':(item.styleId == styleId)}]" v-for="(item,index) in carlist" v-bind:data-rel="brandId+'@#'+item.styleId" class="hide"><span>{{item.styleName}}</span>
									<em></em>
								</li>
								<li @click="checkCarStyle(item.styleId)" v-if="(carNums > 7)" :data-rel="3" id="togglecar" class="togglecar togglecarhide"><span>全部<span class="allarror">&rsaquo;</span></span>
								</li>
							</ul>
						</div>
						<div style="display:none;" class="clearfix form-contril">
							<input name="phone" maxlength="11" autocomplete="off" id="detailForm-phone" class="detailForm-phone" type="number" placeholder="请输入购车人手机号码" />
							<span class="help-inline"></span>
						</div>
						<div class="clearfix form-contril">
							<input name="phone" maxlength="11" autocomplete="off" id="detailForm-phone_new" class="detailForm-phone" type="number" placeholder="请输入购车人手机号码" />
							<span class="help-inline"></span>
						</div>

						<!-- 报名验证码开始  -->
						<!-- <div v-if="isCheckCode ==1" id="getcodewarp" class="clearfix form-contril getcodewarp">
							<input name="verify" autocomplete="off" class="detailForm-code" type="text" placeholder="请输入验证码" />
							<button type="button" id="detailForm-code-button" class="detailForm-code-button">获取验证码</button>
							<button style="display:none;" id="detailForm-code-button-disabled" type="button" disabled="disabled" class="detailForm-code-button-disabled"><span id="secondcutshow"></span>秒</button>
							<span class="help-inline"></span>
						</div> -->

						<!-- 报名验证码结束 -->
						<div style="display:none;" class="clearfix form-contril">
							<input name="name" autocomplete="off" id="detailForm-name" class="detailForm-name" type="text" placeholder="请输入购车人姓名" />
							<span class="help-inline"></span>
						</div>
						<div class="clearfix form-contril">
							<input name="name" autocomplete="off" id="detailForm-name_new" class="detailForm-name" type="text" placeholder="请输入购车人姓名" />
							<span class="help-inline"></span>
						</div>
						<div class="clearfix form-contril">
							<!-- 所有城市购车方式走的都是接口 -->
							<em class="bottom"></em>
							<select name="buyType" class="detailForm-nogroup-shopway" id="buyType">
								<option value="">请选择购车方式</option>

								<option v-for="(item,index) in relustBuyCars" :value="item.value">{{item.name}}</option>
							</select>
							<span class="help-inline"></span>
						</div>

						<div class="clearfix form-contril">
							<!-- 添加购买方式 -->
							<em class="bottom"></em>
							<select name="splitMoney" class="detailForm-nogroup-splitmoney" id="splitMoney">
								<option value="">请选择是否分期</option>
								<option value="0">全款</option>
								<option value="1">分期</option>
							</select>
							<span class="help-inline"></span>
						</div>
					</div>
					<div id="error-message" class="error-message"></div>
					<div class="improve_x" style="background:none;">
						<p class="gray" style="padding-top:1em;text-align:center;"><span class="xieyi"></span><input style="display:none;" type="checkbox" checked="checked" class="result">
							<a :href="msite_static_url+'/default/xieyi.html'">同意《个人信息保护声明》</a>
						</p>
					</div>
					<button type="button" class="detailForm-submit" @click="subApply()">立即报名</button>
					<!--
       <div class="detailForm-tip">您的信息仅供团车网使用，请放心报名！</div>
         -->
                 	<!--新增经销商-->
					<div class="dealerwrap">
						<div class="dealerTit">
							<em>【北京】</em> 已为推荐经销商服务
						</div>
						<ul class="dealerListwrap">
							<li v-for="(item,index) in curperlist">
								<em :class="item.show?'redicon':'chekgrayClass'"  @click="isShow(item.id)"></em>
								<div class="delName" style="width:5rem;text-align:left;padding-left: 2em;">
									<em class="redsize">4s店</em> {{item.nickName}}
								</div>	
								<a href="tel:4001-501-501" class="redphone"></a>
							</li>
						</ul>
						<div class="getMore" @click="getMoretext">{{words}}
					       <em :class="showAll ?'redicon-t' : 'arrorIcon'"></em>
			        	</div>
					</div>
				</form>
			</section>
			<!--团车保证 start-->
			<section>
				<h2 id="formUp" class="clearfix detail-tit">团车保证</h2>
				<div class="clearfix promise-warp">
					<dl class="promise promise01" v-for="(item,index) in tc_bz">
						<dt><em :style="'background:url('+item.imgurl+');background-size:100% 100%;'"></em>{{item.title}}</dt>
						<dd>{{item.describe}}</dd>
					</dl>
				</div>
			</section>

			<!-- 优质合作4s店 开始 -->
			<!--  动静分离版本暂无-->
			<!--<section v-show="hideTradingAreas">
				<h2 id="formUp" class="clearfix detail-tit">优质合作4s店</h2>

				<div class="highquality clearfix" v-for="(item,index) in TradingAreas">
					<div class="imgbox">
						<a :href="'host_name'+'/TradingArea/detailCarShop/?city='+choosecity.py+'&brandId='+brandid+'&dealerId=item.dealerId'">

							<img class="scrollLoading" :src="commmonWebConfig.staticWap01+'/public/images/blank.gif'" data-url="commmonWebConfig.staticWap01+'item.listPic'" />
						</a>

					</div>
					<div class="shopaddress">
						<a :href="'host_name'+'/TradingArea/detailCarShop/?city='+choosecity.py+'&brandId='+brandid+'&dealerId=item.dealerId'">
							<dl class="shoptitle">{{item.nickName}}</dl>
						</a>
						<em></em>
						<dl class="center">地址：{{item.address}}</dl>
					</div>

					<a v-show="hidenewsList" v-for="(item,index) in newsList" :href="'host_name'+'/TradingArea/detailActivity/?city='+choosecity.py+'&brandId='+brandid+'&dealerId=item.dealerId &zxId=item.id}'">
						<dl class="chang">促销：{{item.title}}</dl>
					</a>

				</div>
			</section>-->
			<!-- 优质合作4s店 结束 -->
			<!--评价 start-->
			<section v-if="groupinfo.comment.commentList.length>0">
				<div class="clearfix comment">
					<div class="clearfix detail-tit">
						<span>购车评价</span>
						<div rel="M" class="clearfix fr star star-m">
							<input class="starValue" type="hidden" :value="'5,'+groupinfo.comment.commentTotal" />
							<div class="fl star-ul-wrap">
							</div>
							<div class="fl star-score"><span class="star-score-num"></span>分</div>
						</div>
					</div>
					<ul class="comment-list">
						<li class="clearfix comment-list-li" v-for="(item,index) in groupinfo.comment.commentList">
							<div class="clearfix comment-top">
								<div class="fl comment-user">
									<img :src="commmonWebConfig.picHost+item.memberPic">
								</div>
								<div class="fl">
									<div class="comment-name">{{item.userName =="" ? '匿名': item.userName}}</div>
									<div class="clearfix">
										<div rel="S" class="fl star star-s">
											<input class="starValue" type="hidden" :value="'5,'+item.score" />
											<div class="fl star-ul-wrap">
											</div>
										</div>
									</div>
								</div>
							</div>
							<p class="comment-detail">
								{{item.content}}
							</p>
							<ul class="clearfix comment-imgList">
								<li class="clearfix" v-for="(itemIn,indexIn) in item.commentPicList">
									<img v-lazy="itemIn" />
									}
								</li>

							</ul>
						</li>
					</ul>
				</div>
				<a class="comment-more" :href="host_name+'/'+cityPy+'/b'+brandinfo.id+'/evaluate/'"><span class="red">查看全部{{groupinfo.comment.count}}条评价</span><em></em></a>
			</section>
			<!--评价 end-->
			<!--往期回顾 start-->
			<section class="indexlist" v-show="hidezsixunList">
				<h2 class="clearfix detail-tit"><span class="fl">往期团车节</span><a class="fr gray" :href="'host_name'+'/zixun/wqList?cityid='+cityId+'&brandid='+brandId+''">更多&gt;</a></h2>
				<div class="news-wrap">
					<ul class="clearfix news">
						<li class="clearfix" v-for="(item,index) in zixunList">
							<a :href="item.linkUrl">
								<p class="news-link">{{item.title}}</p>
								<p class="news-date">{{item.clickCount}}次点击&nbsp;&nbsp;&nbsp;{{item.pubDate}}</p>
								<div class="news-img">
									<div v-if="!item.wapImage">
										<!--<img  class="scrollLoading" :src="commmonWebConfig.staticWap01+'/public/images/blank.gif'"  data-url="commmonWebConfig.staticWap01+'item.wapImage'" /> -->

										<img class="scrollLoading" v-lazy="commmonWebConfig.staticWap01+item.pic" />
									</div>
								</div>
							</a>
						</li>

					</ul>
				</div>
			</section>
			<!--往期回顾 end-->

			<section class="bg-pad" style="margin-bottom:0;">
				<p class="detail-tit">购车问题解答</p>
				<dl class="ques-ans">
					<dd class="clearfix">
						<div class="question fl clearfix">
							<div class="tip-box-left"></div>
							<span class="fl">Q：</span>
							<div>参加团车节有什么好处和优惠？</div>
						</div>
						<div class="answer fr clearfix">
							<div class="tip-box-right"></div>
							<span class="fl w10" style="font-weight:bold;">A：</span>
							<div class="fl">
								<p style="color:#444">省心：专职销售跑店省去您的舟车劳顿</p>
								<p style="color:#444">省时：将全城优惠低价展现给每一位消费者</p>
								<p style="color:#444">省钱：价格优于消费者的自询价格</p>
							</div>
						</div>
					</dd>
					<dd class="clearfix">
						<div class="question fl clearfix">
							<div class="tip-box-left"></div>
							<span class="fl">Q：</span>
							<div>参加团车节VS消费者自购，有何异同？</div>
						</div>
						<div class="answer fr clearfix">
							<div class="tip-box-right"></div>
							<span class="fl w10" style="font-weight:bold;">A：</span>
							<div class="fl">
								<p style="color:#444">相同：标准车型、品牌4S店、标准售后</p>
								<p style="color:#444">不同：省钱省时、增值服务、快乐交友</p>
							</div>
						</div>
					</dd>
					<dd class="clearfix">
						<div class="question fl clearfix">
							<div class="tip-box-left"></div>
							<span class="fl">Q：</span>
							<div>参加团车节要收费吗？</div>
						</div>
						<div class="answer fr clearfix">
							<div class="tip-box-right"></div>
							<span class="fl w10" style="font-weight:bold;">A：</span>
							<div class="fl">全程免费服务，不直接或间接收费<br/>帮您免去4S店收取的部分附加费用</div>
						</div>
					</dd>
				</dl>
			</section>
		</div>
		<section class="sign-top" style="display: block;">
			<a href="#baoming">立即报名</a>
		</section>
		<a id="sallFixed" class="sallFixed" href="javascript:void(0);"></a>
		<!--搜索交互 start-->
		<div id="searching" class="searching">
			<header rel="index" class="searchHeader">
				<a class="fl searchHeader-back" href="javascript:void(0);"></a>
				<div class="fl search">
					<form action="{$host_name}/search/search" method="post">
						<input class="search-btn" type="submit" value="搜索">
						<input id="search-txt" class="search-txt" type="text" name="keyword" value="" placeholder="请输入品牌、车型">
						<em id="search-close" class="search-close" style="display: none;">×</em>
					</form>
				</div>
			</header>

			<!-- <div id="search-hot" class="search-hot" v-show="hidehotCarstyleList">
				<ul class="clearfix search-hot-ul-flex">
					<li v-for="(item,index) in hotCarstyleList">
						<a :href="host_name +'/search/search?keyword='+item.word+''">{{item.word}}</a>
					</li>
					<li>
						<a class="red" :href="host_name+'/'+cityPy+'/plan/'">全部车型</a>
					</li>
				</ul>
			</div> -->
			<div id="search-hot" class="search-hot"> 
				<ul class="clearfix search-hot-ul-flex"> 
			        <li v-for="(item,index) in searchStyleList">                          
			            <a :href="'/'+cityPy+'/c'+item.id+'/tuan'" v-text="item.styleName"></a>
			        </li>
					<li><a class="red" :href="'/'+cityPy+'/plan?cityId='+cityId">全部车型</a></li>  
				</ul> 
			</div> 
			<div id="search-history" class="search-history">
				<ul class="search-history-ul">
					<li v-for="(item,index) in arrKeyWords">
						<a :href="host_name+'/search/search?keyword='+item.vo+''"><em></em>{{item.vo}}</a>
					</li>
				</ul>
				<div id="search-history-btn" class="search-history-btn" v-if="isSerach == 1">
					<a href="javascript:void(0)" class="filter-btn"><em class="filter-btn-icon"></em> 清除搜索历史 </a>
				</div>
			</div>
			<div id="search-resultLink" class="search-resultLink">
				<ul class="search-resultLink-ul">
				</ul>
			</div>
		</div>
		<!--搜索交互 end-->
		<!-- <div id="xp_mark" class="xp_mark"></div>
		<div id="xp_pop" class="xp_pop">
			<div id="xp_pop_people" class="xp_pop_people">
				<img class="scrollLoading" :src="commmonWebConfig.staticWap01+'/public/images/blank.gif'" :data-url="commmonWebConfig.staticWap01+'/images/default/xp.png'" />

				<img id="xp_pop_codeimg" class="xp_pop_codeimg" :src="scanCodeImg">
				<p class="xp_pop_txt">微信号：weituanche</p>
			</div>
			<img id="xp_pop_close" class="xp_pop_close scrollLoading" :src="commmonWebConfig.staticWap01+'/public/images/blank.gif'" :data-url="commmonWebConfig.staticWap01+'/images/default/xpClose.png'" />
		</div> -->
		<footer class="footerindex clearfix" id="common_wd1">
			<a class="fl cityName" href="http://m.tuanche.com/city.html"> 北京<em class="cityName-icon"></em>
			</a>
			<a class="fr mine" href="http://m.tuanche.com/ucenter/mycenter">
				我的
			</a>
			<a class="fr indexlink" href="http://m.tuanche.com/bj"> 首页 </a>
		</footer>
		<footer class="footercommon" id="common_wd2">
			<p>
				<a onclick="openAppAndriod()" class="red download" href="http://download.tuanche.com/app/android/groupbuycar_MDownLoadTips/tuancheapp.apk">下载团车APP</a>
				<a style="border-right:1px solid #666666;" class="red" href="http://m.tuanche.com/about/aboutus">关于团车</a>
				<a class="red" href="http://m.tuanche.com/about/dashiji/">团车事记</a>
			</p>
			<p>
				<a class="red" href="tel:4001501501">客服4001-501-501</a>
			</p>
			<div class="footercommon-gray">
				<p class="gray">团车互联网信息服务（北京）有限公司</p>
				<p class="gray">CopyRight ©2009-2018 TuanChe.com All Rights Reserved</p>
				<p class="gray">京ICP备12044574号-2</p>
			</div>
		</footer>
		<div id="topback" class="topback" style="display:none"></div>

	</div>
</template>
<style scoped lang="less">
	.px2px(@name, @px) {
		@{name}: round(@px / 2) * 1px;
		[data-dpr="2"] & {
			@{name}: @px * 1px;
		}
		// for mx3
		[data-dpr="2.5"] & {
			@{name}: round(@px * 2.5 / 2) * 1px;
		}
		// for 小米note
		[data-dpr="2.75"] & {
			@{name}: round(@px * 2.75 / 2) * 1px;
		}
		[data-dpr="3"] & {
			@{name}: round(@px / 2 * 3) * 1px
		}
		// for 三星note4
		[data-dpr="4"] & {
			@{name}: @px * 2px;
		}
	}
	
	.bodywrap {
		background: #f7f7f7!important;
		overflow-x: hidden;
	}
	
	section {
		margin-bottom: 0.2rem;
	}
	
	.sign-top a {
		line-height: 1rem;
		font-size: 0.5rem;
	}
	
	.tip-box-right {
		top: 0.2rem;
	}
	
	.detail-tit {
		.px2px(font-size, 32px);
	}
	
	.comment-more {
		.px2px(font-size, 28px);
	}
	
	.question,
	.answer {
		padding: 0.2rem;
		margin-bottom: 0.2rem;
		.px2px(font-size, 26px);
	}
	
	.carTAP {
		.px2px(font-size, 28px);
	}
	
	.form-car-tit {
		.px2px(font-size, 28px);
	}
	
	#form-car-select-ul li {
		.px2px(font-size, 26px);
	}
	
	.ques-ans {
		padding: 0 0.4rem;
	}
	
	.tip-box-left {
		width: 0.2rem;
		height: 0.4rem;
		left: -0.2rem;
		margin-top: -0.25rem !important;
	}
	
	.tip-box-right {
		width: 0.2rem;
		height: 0.4rem;
		right: -0.2rem;
		top: 50%;
		margin-top: -0.25rem !important;
	}
	
	footer {
		.px2px(font-size, 24px);
		padding: 0;
	}
	
	footer.footercommon {
		padding-bottom: 1.5rem;
	}
	
	.footerindex {
		padding: 0.8rem 1.5rem 0.4rem 1.333333rem;
		.px2px(font-size, 24px);
	}
	
	.sign-top {
		padding: 0 2%;
		margin-top: 0.2rem;
	}
	
	.improve_x a {
		.px2px(font-size, 28px);
	}
	/*http://localhost:8083/bj/b8/tuan/*/
</style>
<script>
	import { Toast } from 'mint-ui';
	export default {
		name: 'detailBrand',
		data:function() {
			return {
				words: '查看更多经销商',
				showAll: false,
				toLearnList:[],
				curperlist: [],
				bodyIsShow:false,
				cityId: '',
				cityName:'',
				cityPy:'',
				scanCodeImg: 'http://static3.tuanche.com/wap01/dist/images/default/codeimg/bj_detail_m.jpeg',
				hidehotCarstyleList: true,
				hotCarstyleList: [],
				arrKeyWords: [],
				isSerach: 1,
				hidezsixunList: false,
				groupinfo: {
					brandGroupStyleManNum: 0,
					brandGroupStyleNum: 0,
					comment: {
						commentList: [],
						commentTotal: 90,
						count: 6
					}
				},
				promptDiv: false,
				prompt: "你猜猜",
				isCheckCode: 1,
				checkColeUrl: "",
				checkPhoneCodeUrl: "",
				temAddApply: 18,
				serachUrl: 30,
				brand_tuan: '',
				oc: "",
				suggesturl: "",
				carlist: [],
				carNums: 10,
				styleId: null,
				brandinfo: {
					id: 10
				},
				isHave: 1,
				relustBuyCars: [],
				msite_static_url: "http://static3.tuanche.com/wap01/dist",
				tc_bz: [],
				hideTradingAreas: false,
				host_name: "",
				hidenewsList: false,
				newsList: {
					title: ''
				},
				hidezixunList: true,
				zixunList: [],
				brandId: '',
				carStyleId: '',
				phone: '',
				name: '',
				buyType: '',
				splitMoney: '',
				brandName: "",
				brandPic: "",
				//搜索推荐的默认车型
				searchStyleList:[]
			}
		},
		beforeCreate: function() {
			getCommonJsIns.initCSSwap02({
				cssURL: "/css/commons/common.css"
			});
			getCommonJsIns.initCSSwap02({
				cssURL: "/css/default/detail01.css"
			});
			getCommonJsIns.initCSSwap02({
				cssURL: "/css/default/index.css"
			});
		},
		mounted: function() {
			var self = this;
			document.title = "品牌";
			self.cityPy = self.$route.params.cityPy;
			getCommonJsIns.initDefaultJS(self.webReady);
			// getCommonJsIns.initJSwap02({
			// 	jsURL: "/script/default/detailphp01.js",
			// 	callback: function() {
			// 		self.webReady()
			// 	}
			// });
		},
		methods: {
			webReady: function() {
				var self = this;
				this.bodyIsShow = true;
				this.ajaxSubmit.ajax({
					url: this.commmonWebConfig.tuancheapi + this.ajaxSubmit.allUrl.tcBaoZheng,
					//url:"http://oo.tuanche.com:8083/data/data.js"
					type: "get",
					dataType: "json",
					success: function(data) {
						var result = data.response.result;
						if(data.responseHeader.status == 200) {
							for(var i in result){
								self.tc_bz[i] = {};
								self.tc_bz[i].imgurl = result[i].imgurl;
								self.tc_bz[i].title = result[i].title;
								self.tc_bz[i].describe = result[i].describe;
							}
						}
					},
					error: function() {

					}
				});
				this.ajaxSubmit.ajax({
					url: this.commmonWebConfig.tuancheapi + this.ajaxSubmit.allUrl.tcStyle + self.$route.params.cityPy + "/b" + self.$route.params.brandId + "/tuan",
					//url:"http://oo.tuanche.com:8083/data/data.js"
					type: "get",
					dataType: "json",
					success: function(data) {
						self.carlist = [];
						var result = data.response.result;
						if(data.responseHeader.status == 200) {
//							console.log('请求成功');
//							var len =result.styleInfoList.length;
							// for(var i = 0; i < result.styleInfoList.length; i++) {
							// 	self.brandId = result.styleInfoList[i].brandId;
							// 	console.log(self.brandId);
							// 	self.brandName = result.styleInfoList[i].styleName;
							// 	self.groupinfo.brandName = self.brandName;
							// 	//console.log(self.brandName);
							// 	self.brandGroupStyleManNum = result.styleInfoList[i].manNum;
							// 	//console.log(self.brandGroupStyleManNum);
							// 	self.brandPic = result.styleInfoList[i].logo;
							// 	//console.log(self.brandPic);
							// 	self.groupinfo.brandPic = self.brandPic;
							// }
							self.cityId = result.city.id;
							self.cityName = result.city.name;
							self.groupinfo.brandGroupStyleNum = result.sum; //累计数
							self.groupinfo.brandGroupStyleManNum = result.theNum; //本期人数
							self.brandId = result.styleInfoList[0].brandId;

							self.brandName = result.brandName
							var styleList = result.styleInfoList;
							for(var listVal in styleList) {
								var carObj = {
									styleName: styleList[listVal].styleName,
									styleId: styleList[listVal].id,
									brandPic: styleList[listVal].logo,
									brandGroupStyleManNum: styleList[listVal].manNum,
									brandName: styleList[listVal].brandName,
								}
								self.carlist.push(carObj);
							}
							//console.log(self.carlist);
							self.carStyleId = self.carlist[0].styleId;
							self.brandPic = result.brandPic;
							console.log(self.brandPic);
							self.initdelDate();//获取经销商信息
							////购车方式
							self.ajaxSubmit.ajax({
								url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.buyWays,
								type: "get",
								dataType: 'json',
								data: {
									cityId: self.cityId
								},
								success: function(data) {
									var result = data.response.result;
									if(data.responseHeader.status == 200) {
										self.relustBuyCars = data.response.result;
									}
								}
							});

							//评论
							self.ajaxSubmit.ajax({
								url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.tcCommentInfo + "cityId=" + self.cityId + "&" + "brandId=" + self.brandId + "&count=3&offset=1",
								//url:"http://oo.tuanche.com:8083/data/data.js"
								type: "get",
								dataType: "json",
								success: function(data) {
									var result = data.response.result;
									if(data.responseHeader.status == 200) {
										self.groupinfo.comment.commentList = result.commentList;
										self.groupinfo.comment.commentTotal = result.commentTotal;
										self.groupinfo.comment.count = result.count;
									}
									getCommonJsIns.loadJs(self.commmonWebConfig.staticWap01 + "/script/default/detailphp01.js",function(){});
								},
								error: function() {
									getCommonJsIns.loadJs(self.commmonWebConfig.staticWap01 + "/script/default/detailphp01.js",function(){});
								}
							});

							//加载联想词
							self.ajaxSubmit.ajax({
								url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.hotStyles,
								type:"get",
								data:{
									cityId:self.cityId,
									pageSize : 11
								},
								success:function(data){
									if(data.responseHeader.status == 200){
										self.searchStyleList = data.response.result;
										console.log(data.response.result)

									}
									
								}
							});

						}
					},
					error: function() {

					}
				});



			},
			initdelDate: function() {//获取经销商
				var self = this;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.getCustomerList+"?id="+self.cityId+"&brandId="+self.brandId,
					type: "post",
					data: {},
					dataType: 'json',
					async: false,
					success: function(data){
						console.log(data);
						if(data.responseHeader.status == 200) {
                           self.toLearnList = data.response.result;//请求数据赋值
                           for(var i = 0; i < self.toLearnList.length; i++) {
	                           		self.toLearnList[i].show=true;//全选
							}
                           self.showList();
						}else{
							console.log("请求失败");
						}
					},
					error: function() {
						console.log("error");
					}
				});
			},
			isShow:function(id){
				var self=this;
				var couselist1=[];
				for(var i = 0; i < self.curperlist.length; i++) {
					couselist1.push(self.curperlist[i])
						if(self.curperlist[i].id==id){ 
							couselist1[i].show=!self.curperlist[i].show;
						}
						
					}
				self.curperlist=couselist1;
			},
			getMoretext: function() {
				var self = this;
				if(!self.showAll) { //对文字处理
					self.words = '收起'
				} else {
					self.words = '查看更多经销商';
				}
				self.showAll = !self.showAll;
				self.showList();
			},
			showList: function() {
				var self = this;
				self.curperlist = [];
				if(!self.showAll){
					for(var i = 0; i < self.toLearnList.length; i++) {
						if(i < 3) {
							self.curperlist.push(self.toLearnList[i]);
						}
					}
				} else {
					self.curperlist = self.toLearnList;
				}
			},
			checkCarStyle: function(styleId) {
				var self = this;
				self.styleId = styleId;
			},
			subApply: function() {
				var self = this;
				//$(".detailForm-submit").attr("disabled", "disabled");

				var self = this;
				if(!webCommonUtil.commonFun.isName($("#detailForm-name_new").val())){
					Toast({
	                  message: "请填写真实姓名",
	                  position: 'middle',
	                  duration: 2000
	                });
	                return false;
				}else if(!webCommonUtil.commonFun.isPhone($("#detailForm-phone_new").val())){
					Toast({
	                  message: "请填写11位手机号码",
	                  position: 'middle',
	                  duration: 2000
	                });
	                return false;
				}else{
					var dataApply = {
						"sourceUrl": window.location.href,
						"cityId": this.cityId,
						"name": $("#detailForm-name_new").val(),
						"phone": $("#detailForm-phone_new").val(),
						"buyType": $("#buyType option:selected").val(),
						"splitMoney": $("#splitMoney option:selected").val(),
						"brandId": this.brandId,
						"carStyleId": this.carStyleId,
						"checkIp": true,
						"groupbyType": 4,
					};
					//console.log(dataApply);
					self.ajaxSubmit.ajax({
						url:this.commmonWebConfig.tuancheapi+this.ajaxSubmit.allUrl.applyForTcjAsyn,
						type:"post",
						data:dataApply,
						success:function(data){
							//$(".detailForm-submit").removeAttr("disabled");
							if(data.responseHeader.status == 200){
								if($("#buyType option:selected").val() == 1){
									window.location.href = context + "/GroupBuy/addApply?brandId="+self.brandId+"&carStyleId="+self.carStyleId+"&cityId="+self.cityId +"&applyId="+data.response.result.result.applyId+"&sk="+data.response.result.result.sk+ "&buyway=1";
								}else{
									window.location.href = context + "/GroupBuy/addApply?brandId="+self.brandId+"&carStyleId="+self.carStyleId+"&cityId="+self.cityId +"&applyId="+data.response.result.result.applyId+"&sk="+data.response.result.result.sk+ "&buyway=0";
								}
		
							}else {
								Toast({
				                  message: data.response.msg,
				                  position: 'middle',
				                  duration: 2000
				                });
							}
							
						},
						error:function(){
							$(".detailForm-submit").removeAttr("disabled");
							Toast({
			                  message: "系统忙，请稍后",
			                  position: 'middle',
			                  duration: 2000
			                });
						}
					});
				}


				// self.ajaxSubmit.ajax({
				// 	url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyForTcjAsyn,
				// 	type: "post",
				// 	data: dataApply,
				// 	success: function(data) {
				// 		//alert(123);
				// 		$(".detailForm-submit").removeAttr("disabled");
				// 			if(data.responseHeader.status == 200) {
				// 				if($("#buyType option:selected").val() == 1){
				// 					window.location.href = context + "/GroupBuy/addApply?brandId="+self.brandId+"&carStyleId="+self.carStyleId+"&cityId="+self.cityId + "&buyway=1";
				// 				}else{
				// 					window.location.href = context + "/GroupBuy/addApply?brandId="+self.brandId+"&carStyleId="+self.carStyleId+"&cityId="+self.cityId + "&buyway=0";
				// 				} 
				// 			}else {
				// 				Toast({
				// 					message: data.msg,
				// 					position: 'middle',
				// 					duration: 2000
				// 				});
				// 			}

				// 	},
				// 	error: function() {
				// 		$(".detailForm-submit").removeAttr("disabled");
				// 		Toast({
				// 			message: "系统忙，请稍后",
				// 			position: 'middle',
				// 			duration: 2000
				// 		});
				// 	}
				// });

			  }
		

		}
	}
</script>


// WEBPACK FOOTER //
// src/views/signupPhp/detailBrand.vue